<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow" :close-on-click-modal="false">

    <el-form v-loading="isLoading" :model="form" label-width="120px" @submit.native.prevent style="max-width: 1200px;">


      <el-form-item label="活動名稱(繁中)">
        <el-input v-model="form.ActivityTitleTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="活動名稱(英文)">
        <el-input v-model="form.ActivityTitleEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="活動名稱(日文)">
        <el-input v-model="form.ActivityTitleJp"></el-input>
      </el-form-item>
      <el-form-item label="連結">
        <el-input v-model="form.ActivityLink"></el-input>
      </el-form-item>

      <el-form-item label="贈品名稱(繁中)">
        <el-input v-model="form.NameTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="贈品名稱(英文)">
        <el-input v-model="form.NameEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="贈品名稱(日文)">
        <el-input v-model="form.NameJp"></el-input>
      </el-form-item>

      <el-form-item label="圖片" class="text-left">
        <el-upload
          v-loading="isProcessingImage"
          ref="el-upload"
          accept="image/*"
          class="el-upload-gift"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genImageFileParam())">
          <img
            ref="image"
            v-show="form.imageObjectURL || form.ImageURL"
            @load="e => onImageLoaded(e, genImageFileParam())"
            class="preview"
            :src="form.imageObjectURL || form.ImageURL"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form.imageObjectURL || form.ImageURL)" class="el-icon-upload"></i>
          <div class="el-upload__text" v-show="!(form.imageObjectURL || form.ImageURL)">
            1080x1080
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="數量">
        <el-input v-model="form.Count" type="number" min="0" step="1"></el-input>
        <!-- <p class="hint">0或留空則代表沒有兌換數量上限</p> -->
      </el-form-item>

      <el-form-item label="單位">
        <el-input v-model="form.UnitTitle"></el-input>
      </el-form-item>
      
      <el-form-item label="開始時間">
        <el-date-picker v-model="form.BeginAt" class="left" type="datetime" placeholder="選擇日期" style="width: 200px;"></el-date-picker>
        <label class="el-form-item__label" style="width: 80px;">結束時間</label>
        <el-date-picker v-model="form.EndAt" class="left" type="datetime" placeholder="選擇日期" style="width: 200px;"></el-date-picker>
      </el-form-item>

      <el-form-item label="指定商品">
        <el-select style="width: 100%;" filterable v-model="form.ProductIDs" :multiple="true" placeholder="請選擇商品">
          <template slot="empty">
            <p class="el-select-dropdown__empty">沒有資料</p>
          </template>
          <el-option
            v-for="item in activeProducts"
            :key="item.ID"
            :label="item.Tw.Name"
            :value="item.ID">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="最低購買金額">
        <el-input v-model="form.OrderAmount"></el-input>
      </el-form-item>

      <el-form-item label="狀態">
        <el-switch
          v-model="form.PublishStatus"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinProcessImageFile],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        NameTw: '',
        NameEn: '',
        NameJp: '',
        ActivityTitleTw: '',
        ActivityTitleEn: '',
        ActivityTitleJp: '',
        ImageURL: '',
        PublishStatus: 2,
        Weigh: 0,
        IsActive: true,
        IsTop: false
      },
      mIsShow: false,
      isLoading: false,
      isProcessingImage: false,
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.NameTw : '新增贈品'
    },
    activeProducts () {
      return this.$store.state.product.list.filter(o => o.IsActive && !o.TeamBuyingID)
    },
  },
  methods: {
    // for base
    setLoading(key, isLoading) {
      this.isLoading = isLoading
    },
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.Weigh = parseInt(this.form.Weigh)
      this.form.Count = parseInt(this.form.Count) || 0
      this.form.OrderAmount = parseInt(this.form.OrderAmount) || 0

      let promise = this.isEdit
        ? this.$services.gift.edit(this, this.form.ID, this.form)
        : this.$services.gift.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Weight: 0, IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.gift.list.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.gift.list.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.gift.list.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown gift for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.ActivityLink) {
        errMsg = '請輸入活動連結'
      }
      if (!this.form.ImageURL) {
        errMsg = '請上傳圖片'
      }
      if (!this.form.NameTw) {
        errMsg = '請輸入繁中名稱'
      }
      if (this.languages.includes('En') && !this.form.NameEn) {
        errMsg = '請輸入英文名稱'
      }
      if (this.languages.includes('Jp') && !this.form.NameJp) {
        errMsg = '請輸入日文名稱'
      }

      if (!this.form.ActivityTitleTw) {
        errMsg = '請輸入繁中活動名稱'
      }
      if (this.languages.includes('En') && !this.form.ActivityTitleEn) {
        errMsg = '請輸入英文活動名稱'
      }
      if (this.languages.includes('Jp') && !this.form.ActivityTitleJp) {
        errMsg = '請輸入日文活動名稱'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    genImageFileParam () {
      let requiredSize = { w: 1080, h: 1080 }
      // 當我們上傳圖片後，
      let params = {
        'isProcessingImageKey': 'isProcessingImage',
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'el-upload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'image',
        // 要上傳的表單 form
        'formObject': this.form,
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'imageObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'ImageURL'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒名稱後才會上傳
        'blobObjKeys': [
          'imageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `gift/${this.form.ID}/`
            : `gift/${this.form.NameTw}-`
        ]
      }
      return params
    },
  },
  created () {
    this.mIsShow = this.isShow

    if (
      !this.$store.state.product.isFetched &&
      !this.$store.state.product.isFetching
    ) {
      this.$services.fetchProductDatas(this)//.then(initTableData).catch(this.$handleServiceError)
    }
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            Weigh: 0,
            IsActive: true
          }
        }
      }
    }
  }
}
</script>


<style>
.el-upload-gift {

}
.el-upload-gift {
  height: 150px;
  float: left;
  display: inline-block;
}

.el-upload-gift .el-upload-dragger {
  width: 150px;
  height: 150px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.el-upload-gift .el-icon-upload {
  margin: 0 !important;
}
</style>